<template>
	<div class="container switch-page">
		<!-- 头部导航 -->
		<header-bar name='待审陪诊人' />
		
		<div class="wrap-box">
			<div class="hd">基本信息</div>
			<div class="profile-wrap">
				<div class="row">
					<div class="lab">姓名</div>
					<div class="inf">{{ fromData.name }}</div>
				</div>
				<div class="row">
					<div class="lab">性别</div>
					<div class="inf">{{ fromData.sex == 0 ? '男' : '女' }}</div>
				</div>
				<div class="row">
					<div class="lab">年龄</div>
					<div class="inf">{{ fromData.age }}</div>
				</div>
				<div class="row">
					<div class="lab">居住地</div>
					<div class="inf">{{ fromData.address }}</div>
				</div>
				<div class="row">
					<div class="lab">身份证号</div>
					<div class="inf">{{ fromData.number }}</div>
				</div>
				<div class="row">
					<div class="lab">有无驾照</div>
					<div class="inf">{{ fromData.drivingLicense == 1 ? '有' : '没有'  }}</div>
				</div>
				<div class="row">
					<div class="lab">联系电话</div>
					<div class="inf">{{ fromData.phone }}</div>
				</div>
				<div class="row">
					<div class="lab">备用电话</div>
					<div class="inf">{{ fromData.alternatePhone }}</div>
				</div>
				<div class="address">
					<div class="lab">详细地址</div>
					<div class="inf">{{ fromData.detailedAddress }}</div>
				</div>
			</div>
		</div>
		
		<div class="wrap-box">
			<div class="hd">自我介绍</div>
			<div class="introduction" v-html="fromData.selfIntroduction">
			</div>
		</div>

		<div class="wrap-box">
			<div class="hd">证件信息</div>
			<div class="license-list">
				<img class="item" :src="fromData.idCardFront" />
				<img class="item" :src="fromData.idCardBack" />
			</div>
		</div>

		<div class="wrap-box">
			<div class="hd">申请陪诊医院</div>
			<div class="hospital-list">
				<div class="item" v-for="(item, index) in hospitalAddress" :key="index">{{ item }}</div>
			</div>
		</div>

		<div class="fixed-link">
			<div class="lnk-item lnk-ok" :data-id='fromData.id' :data-phone='fromData.phone' @click="handlerDo">通过</div>
			<div class="lnk-item lnk-no" :data-id='fromData.id' :data-name='fromData.name' :data-phone='fromData.phone'  @click="handlerClose">拒绝</div>
		</div>

    <van-overlay :show="flagModels">
      <div class="model-box">
        <div class="hd">
          <div class="name">拒绝</div>
          <div class="link" @click="flagModels = false"><img class="ico" src="~assets/images/icon-close.png" /></div>
        </div>
        <div class="bd">
          <div class="area">
            <div class="lab required">请输入拒绝原因</div>
            <div class="txt">
              <textarea class="text" v-model="refuseReason"></textarea>
            </div>
          </div>
        </div>
        <div class="ft">
          <div class="link" @click="handlerSaveTask">提交</div>
        </div>
      </div>
    </van-overlay>
		
	</div>
</template>

<script>
	import HeaderBar from 'components/HeaderBar/HeaderBar'
  import {attendantAudit, attendantDetail, sendSms} from '@/api/home'
	export default{
		name: 'MemberDetail',
		components: {
			HeaderBar
		},
		data() {
			return {
        fromData: {
          name:'',
          sex:'',
          age:'',
          address:'',
          number:'',
          drivingLicense:'',
          phone:'',
          alternatePhone:'',
          detailedAddress:'',
          selfIntroduction:'',
          idCardFront:'',
          idCardBack:'',
        },
        hospitalAddress: [],
        flagModels: false,
        refuseReason: '',
        refuseId: '',
        name: '',
        phone: ''
			}
		},
		methods: {
		  show: function(id) {
        attendantDetail(id).then(res => {
          this.fromData = res==null?{}:res
          //根据身份证号获取年龄
          this.fromData.age = this.getAge(this.fromData.number)
          this.hospitalAddress = this.fromData.hospitalAddress != null && this.fromData.hospitalAddress != '' ? this.fromData.hospitalAddress.split(',') : []
        })
      },
      getAge: function(idCard) {
        var len = (idCard + "").length;
        if (len == 0) {
          return 0;
        } else {
          if ((len != 15) && (len != 18)) {
            return 0;
          }
        }
        var strBirthday = "";
        if (len == 18) {
          strBirthday = idCard.substr(6, 4) + "/" + idCard.substr(10, 2) + "/" + idCard.substr(12, 2);
        }
        if (len == 15) {
          strBirthday = "19" + idCard.substr(6, 2) + "/" + idCard.substr(8, 2) + "/" + idCard.substr(10, 2);
        }
        var birthDate = new Date(strBirthday);
        var nowDateTime = new Date();
        var age = nowDateTime.getFullYear() - birthDate.getFullYear();
        var month = nowDateTime.getMonth() - birthDate.getMonth();
        if (month < 0) {
          age--;
        } else {
          if (month == 0) {
            var day = nowDateTime.getDay() - birthDate.getDay();
            if (day < 0) {
              age--;
            }
          }
        }
        return age;
      },
      //通过
      handlerDo: function (e) {
        let eCode = e.currentTarget.dataset.id
        let phone = e.currentTarget.dataset.phone
        this.$dialog.confirm({
          title: '系统提示',
          message: '您确定要通过陪诊人吗？'
        }).then(() => {
          attendantAudit({ id: eCode, state:4 }).then(res => {
            this.$toast('审核成功')
            sendSms({ phone: phone, type: 'THE_COMPANION_WAS_APPROVED' ,data:{ signName: ""} }).then(res => {

            })
            this.$router.go(-1);
            // this.$router.push({path: '/member-list'}) //跳转到列表页点击返回会回到详情页
          })
        }).catch(() => {
        })
      },

      //拒绝
      handlerClose: function (e) {
        this.refuseReason = ''
        this.refuseId = e.currentTarget.dataset.id
        this.name = e.currentTarget.dataset.name
        this.phone = e.currentTarget.dataset.phone
        this.flagModels = true
      },

      handlerSaveTask: function () {
        if(this.refuseReason.length <= 0) {
          this.$toast('请输入拒绝原因')
          return;
        }
        attendantAudit({ id: this.refuseId, refuseReason: this.refuseReason, state: 3 }).then(res => {
          this.$toast('拒绝成功: 已拒绝'+this.name+'成为陪诊人')
          sendSms({ phone: this.phone, type: 'THE_COMPANION_REVIEW_WAS_NOT_APPROVED',data: { signName: "" } }).then(res => {

          })
          this.flagModels = false;
          this.$router.go(-1);
          // this.$router.push({path: '/member-list'}) //跳转到列表页点击返回会回到详情页
        })
      },

		},
		mounted: function(){
      console.log(this.$route.query.id)
			this.show(this.$route.query.id)
		}
	}
</script>

<style scoped>
.wrap-box{ padding: 0 0.2rem; margin: 0.2rem 0.2rem 0; background: #FFF; border-radius: 0.2rem;}
.wrap-box>.hd{ height: 0.88rem; line-height: 0.88rem; color: #111; font-size: 0.28rem; font-weight: 600; display: flex; justify-content: flex-start; align-items: center; }
.wrap-box>.hd::before{ position: relative; content: ''; margin: 0 0.1rem 0 0; width: 0.08rem; height: 0.32rem; background: #3f58fd;}
.hospital-list{ display: flex; flex-wrap: wrap; margin: -0.1rem 0 0 0; padding: 0 0 0.2rem;}
.hospital-list>.item{ height: 0.56rem; line-height: 0.56rem; font-size: 0.25rem; padding: 0 0.12rem; background: rgba(0, 0, 0, 0.1); border-radius: 0.1rem; margin: 0.1rem 0.1rem 0 0;}

.license-list{ display: flex; justify-content: center; align-items: center; flex-direction: column; padding: 0 0 0.2rem;}
.license-list>.item{ width: 6.7rem; height: 4.5rem; margin: 0.2rem 0 0;}
.license-list>.item:first-of-type{ margin: 0;}

.introduction{ padding: 0 0 0.2rem; color: #565656; font-size: 0.28rem; line-height: 0.48rem;}

.profile-wrap{ padding: 0 0 0.2rem; font-size: 0.28rem;}
.profile-wrap>.row{ position: relative; height: 0.8rem; line-height: 0.8rem; display: flex; justify-content: space-between; align-items: center;}
.profile-wrap>.row::after{ position: absolute; content: ''; left: 0; right: 0; bottom: 0; height: 1px; background: rgba(0, 0, 0, 0.04);}
.profile-wrap>.row>.lab{ color: #999; position: relative;}
.profile-wrap>.row>.lab::after{ position: relative; content: '：';}
.profile-wrap>.row>.inf{ color: #555;}
.profile-wrap>.address{ color: #555; line-height: 0.4rem;}
.profile-wrap>.address>.lab{ color: #999; height: 0.8rem; line-height: 0.8rem;}

.fixed-link{ position: fixed; bottom: 0; left: 0; right: 0; height: 1rem; background-color: #fff; z-index: 777; box-shadow: 0 0 0.1rem rgba(0, 0, 0, .1); padding: 0 0.2rem; display: flex; justify-content: flex-end; align-items: center;}
.fixed-link>.lnk-item{ height: 0.6rem; line-height: 0.6rem; padding: 0 0.24rem; margin: 0 0 0 0.2rem; border-radius: 0.12rem;}
.fixed-link>.lnk-ok{ background: #1890FF; border: 1px solid #1890FF; color: #FFF;}
.fixed-link>.lnk-no{ background: #ff4d4f; border: 1px solid #ff4d4f; color: #FFF;}
</style>